import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Media from 'react-media';
import mediaQueries from '../../../utils/mediaQueries';
import { toolsDogFootprint, guideLines } from '../../../assets/illustrations/illustrationRepository';

const Container = styled.div`
  display: grid;
  grid-template-columns: 100%;
  justify-items: center;
  position: relative;
  &:nth-child(2),
  &:nth-child(4) {
    margin-top: 26px;
  }
  @media ${mediaQueries.xlPlusUp} {
    grid-template-columns: repeat(3, max-content);
    justify-content: center;
    &:nth-child(2) {
      margin-top: 122px;
    }
    &:nth-child(3) {
      margin-top: 148px;
    }
    &:nth-child(4) {
      margin-top: 152px;
    }
  }
`;
const ImageContainer = styled.div`
  width: ${({ size }) => size};
  @media ${mediaQueries.xlPlusUp} {
    order: ${({ order }) => order};
  }
`;
const Image = styled.img`
  width: 100%;
`;
const DescriptionContainer = styled.div`
  max-width: 312px;
  margin-top: 24px;
  @media ${mediaQueries.xlPlusUp} {
    display: grid;
    align-content: center;
    order: 2;
    margin-top: 0;
    margin-right: ${({ marginRight }) => marginRight};
    margin-left: ${({ marginLeft }) => marginLeft};
  }
`;
const Title = styled.h3`
  color: ${({ theme }) => theme.colors.black3E};
  font-weight: 600;
  font-size: 30px;
  line-height: 100%;
  @media ${mediaQueries.xlPlusUp} {
    font-size: 40px;
    line-height: 54px;
  }
`;
const Description = styled.p`
  color: ${({ theme }) => theme.colors.black3E};
  font-size: 18px;
  line-height: 25px;
  margin: 0;
  margin-top: 22px;
  @media ${mediaQueries.xlPlusUp} {
    margin-top: 0;
    line-height: 26px;
  }
`;
const PiperContainer = styled.div`
  width: ${({ size }) => size};
  margin-top: ${({ marginTop }) => marginTop};
  position: relative;
  @media ${mediaQueries.xlPlusUp} {
    order: ${({ order }) => order};
  }
`;
const Piper = styled.img`
  width: 100%;
`;
const DogFootprintContainer = styled.div`
  position: absolute;
  bottom: 68px;
  left: 92px;
`;
const DogFootprint = styled.img``;
const GuideLineContainer = styled.div`
  position: absolute;
  top: ${({ top }) => top || '-220px'};
`;
const GuideLine = styled.img``;

const Tool = ({ tool }) => (
  <Media queries={mediaQueries}>
    {(matches) => (
      <Container>
        <ImageContainer
          size={
            matches.xlPlusDownLess
              ? tool.image.size.mobile
              : tool.image.size.desktop
          }
          order={tool.image.order}
        >
          <Image src={tool.image.desktop} alt={tool.title} />
        </ImageContainer>
        <DescriptionContainer
          marginRight={tool.descriptionMargin.right}
          marginLeft={tool.descriptionMargin.left}
        >
          <Title>{tool.title}</Title>
          <Description>{tool.description}</Description>
        </DescriptionContainer>
        <PiperContainer
          size={
            matches.xlPlusDownLess
              ? tool.piper.size.mobile
              : tool.piper.size.desktop
          }
          marginTop={tool.piper.marginTop}
          order={tool.piper.order}
        >
          <Piper src={tool.piper.image} alt="Piper" />
          {(tool.id === 'toolPost' && matches.xlPlusUp) && (
            <DogFootprintContainer>
              <DogFootprint src={toolsDogFootprint} alt="Dog Footprint" />
            </DogFootprintContainer>
          )}
        </PiperContainer>
        {(tool.id === 'toolPost' && matches.xlPlusUp) && (
          <GuideLineContainer>
            <GuideLine src={guideLines.guideLine1} alt="Guide Line" />
          </GuideLineContainer>
        )}
        {(tool.id === 'toolBlastoff' && matches.xlPlusUp) && (
          <GuideLineContainer>
            <GuideLine src={guideLines.guideLine2} alt="Guide Line" />
          </GuideLineContainer>
        )}
        {(tool.id === 'toolConnect' && matches.xlPlusUp) && (
          <GuideLineContainer top="-240px">
            <GuideLine src={guideLines.guideLine3} alt="Guide Line" />
          </GuideLineContainer>
        )}
      </Container>
    )}
  </Media>
);

Tool.propTypes = {
  tool: PropTypes.shape({
    id: PropTypes.string.isRequired,
    image: PropTypes.shape({
      desktop: PropTypes.string.isRequired,
      order: PropTypes.number.isRequired,
      size: PropTypes.shape({
        mobile: PropTypes.string.isRequired,
        desktop: PropTypes.string.isRequired,
      }),
    }),
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    piper: PropTypes.shape({
      image: PropTypes.string.isRequired,
      order: PropTypes.number.isRequired,
      size: PropTypes.shape({
        mobile: PropTypes.string.isRequired,
        desktop: PropTypes.string.isRequired,
      }),
      marginTop: PropTypes.string.isRequired,
    }),
    descriptionMargin: PropTypes.shape({
      right: PropTypes.string.isRequired,
      left: PropTypes.string.isRequired,
    }),
  }).isRequired,
};

export default Tool;
